import React from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import api from '../../services/api';
import Swal from "sweetalert2";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalImportarTimeSheet = ({
    isOpen,
    idTimesheet,
    onAfterOpen,
    onRequestClose,
    importData,
    timesheet,
    totalAtividades,
    listaItemAtividades,
    quantidadeHoras,
    valorTotal,
    alertData,
    grupoAtividades
}) => {
    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const importarTimeSheetPost = async () => {
        if (importData?.data?.mensagens?.length > 0) {
            registrationFailure(`Importação possui ${importData?.data?.mensagens?.length} ocorrências, revise as ocorrências e tente novamente.`)
        }
        else {


            Swal.fire({
                title: 'Aguarde...',
                html: 'Enviando importação TimeSheet.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading()
                },
            });


            let result = null;

            try {
                const response = await api.post(`Timesheet/import/confirm`, { ...importData.data, idTimesheet: idTimesheet });
                Swal.close();
                onRequestClose();
                registrationSuccess();
                result = response.data;

                window.location.reload(false);
            } catch (err) {
                registrationFailure();
                return result;
            }
        }
    };

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Importação realizada com sucesso",
            icon: "success",
            confirmButtonText: "OK",
        });
    }

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar a importação. Verifique todas as informações e tente novamente. Caso persista procure suporte.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            timesheet={timesheet}
            importData={importData}
            contentLabel="Timesheet Atividades"
            style={style}
            itensAtividades={listaItemAtividades}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
            grupoAtividades={grupoAtividades}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <p className="modal-title">Importar TimeSheet</p>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">TimeSheet</p>
                                <p className="modal-info-data"> {timesheet.timesheet.numeroTimesheet} </p>
                                <p className="modal-info">Segurado </p>
                                <p className="modal-info-data">{timesheet.segurado.seguradoNome}  </p>
                                <p className="modal-info">Quantidade de linhas</p>
                                <p className="modal-info-data">{totalAtividades} </p>
                            </div>
                        </div>
                    </Flex.Item>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <p className="modal-title"></p>
                            <div>
                                <p className="modal-info">Pericia/Disciplina </p>
                                <p className="modal-info-data">{timesheet.pericia.sigla}  </p>
                                <p className="modal-info">Total Horas </p>
                                <p className="modal-info-data"> {quantidadeHoras}</p>
                            </div>
                        </div>
                    </Flex.Item>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <p className="modal-title"></p>
                            <div>
                                <p className="modal-info">Cliente </p>
                                <p className="modal-info-data">{timesheet.cliente.clienteNome}  </p>
                                <p className="modal-info">Valor Total</p>
                                <p className="modal-info-data"> {valorTotal} </p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item>
                        <div className="position-relative form-group modal-width">
                            <p className="modal-width modal-title">Notificações de Importação</p>
                        </div>
                    </Flex.Item>
                </Flex>
                <Flex.Item>
                    <div>
                        <p className="modal-info">{alertData} ocorrências</p>
                    </div>

                    <div>
                        {importData?.data?.mensagens?.map((item, _index) => {
                            return (
                                <p className="modal-info" Key={item.descricao}>{item.descricao}</p>
                            )
                        })}
                    </div>
                </Flex.Item>
                <br />
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group modal-align-center">
                            <input className='default-button-red' value='Cancelar' type="button" onClick={onRequestClose} />
                        </div>
                    </Flex.Item>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group modal-align-center">
                            {importData?.data?.mensagens?.length > 0}
                            <input className='default-button-red' value='Importar' type="button" onClick={importarTimeSheetPost} />
                        </div>
                    </Flex.Item>
                </Flex>
            </StyledForm>
        </Modal>
    );
};
